<p-toast />

<form (ngSubmit)="accept()" [formGroup]="actionPlanForm">
  <div class="grid formgrid mt-4">
    <div class="col-12 mb-3">
      <span class="p-fluid p-float-label">
        <p-autoComplete formControlName="event" [suggestions]="events" (completeMethod)="filterEvent($event)"
          field="title" [dropdown]="true" [forceSelection]="true" inputId="event">
        </p-autoComplete>
        <label for="event">Evento *</label>
      </span>
    </div>

    <div class="col-12 mb-3 lg:col-6">
      <span class="p-fluid p-float-label">
        <p-autoComplete formControlName="root_cause" [suggestions]="rootCauses"
          (completeMethod)="filterRootCause($event)" field="name" [dropdown]="true" [forceSelection]="true"
          inputId="root_cause">
        </p-autoComplete>
        <label for="root_cause">Causa Raíz *</label>
      </span>
    </div>

    <div class="col-12 mb-3 lg:col-6">
      <span class="p-fluid p-float-label">
        <p-autoComplete formControlName="qualification" [suggestions]="qualifications"
          (completeMethod)="filterQualification($event)" field="name" [dropdown]="true" [forceSelection]="true"
          inputId="qualification">
        </p-autoComplete>
        <label for="qualification">Calificación *</label>
      </span>
    </div>

    <div class="col-12 mb-3">
      <span class="p-fluid">
        <textarea formControlName="description" placeholder="Descripción" rows="4" cols="30" pInputTextarea></textarea>
      </span>
    </div>
  </div>

  <div class="button-group mt-4">
    <button pButton pRipple type="submit" [disabled]="actionPlanForm.invalid" label="Guardar"
      class="p-button-raised"></button>

    <button (click)="cancel()" pButton pRipple type="button" label="Cancelar"
      class="p-button-raised p-button-secondary"></button>
  </div>
</form>